/*
    Get old house member id
    There is no equivalent in new house as
    EFID doesn't necessary associate with member account
*/
define('shared/my/identity',[
    'shared/util/state', 
    'shared/util/state/adapters/user'
], function (
    state, 
    userAdapter
) {
    return function(){
        return state.adapters.add(userAdapter)
            .then(function(){
                return state.get('user.member_id');
            })
            .then(function(values){
                return values[0] || '';
            });
    };
});
